// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppUserSchema } from './v1/appUserSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const getAppConnectionStatusPathParamsSchema = z.object({
  id: z.number().int().describe("App id"),
});

export const getAppConnectionStatusHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Connection status
 */
export const getAppConnectionStatus200Schema = z.array(z.lazy(() => v1AppUserSchema));

/**
 * @description App not found
 */
export const getAppConnectionStatus404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const getAppConnectionStatusQueryResponseSchema = z.lazy(() => getAppConnectionStatus200Schema);
